import { get } from '@/helpers/httpHandler';

export default {
  getTypes(_, params) {
    return get(`/documents/list-of-documents/items/types`, params);
  },

  getFilteredLinks(_, params) {
    return get(`/documents/filter/links`, params);
  },
  getFilteredFiles(_, params) {
    return get(`/documents/filter/files`, params);
  },
  getFilteredLists(_, params) {
    return get(`/documents/filter/lists`, params);
  }
};
